import { render, staticRenderFns } from "./LeavePolicies.vue?vue&type=template&id=a444799e"
import script from "./LeavePolicies.vue?vue&type=script&lang=js"
export * from "./LeavePolicies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports